import { render } from "./WallGuard.vue?vue&type=template&id=1c27b810&scoped=true&ts=true"
import script from "./WallGuard.vue?vue&type=script&lang=ts"
export * from "./WallGuard.vue?vue&type=script&lang=ts"

import "./WallGuard.vue?vue&type=style&index=0&id=1c27b810&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c27b810"]])

export default __exports__